module.exports = __webpack_public_path__ + "img/bg_select.0e269a06.png";